export const PAGE_RATING_LIFETIME = 30; // days
